// src/components/portfolio/add-asset/services/BistService.js
import { db } from '../../../../services/firebase/config';
import { collection,  getDocs, doc, getDoc } from 'firebase/firestore';

export class BistService {
    static stocksCache = null;
    static lastFetchTime = null;
    static CACHE_DURATION = 1000 * 60 * 60; // 1 saat

    // Cache'i kontrol et ve gerekirse yenile
    static async ensureCache() {
        const now = Date.now();
        if (this.stocksCache && this.lastFetchTime && (now - this.lastFetchTime < this.CACHE_DURATION)) {
            return;
        }

        try {
            const bistMapRef = collection(db, 'bistMap');
            const snapshot = await getDocs(bistMapRef);
            
            this.stocksCache = new Map();
            snapshot.forEach(doc => {
                this.stocksCache.set(doc.id, doc.data());
            });
            
            this.lastFetchTime = now;
            console.log('BistMap cache yenilendi');
        } catch (error) {
            console.error('Cache yenileme hatası:', error);
            throw error;
        }
    }

    // Hisse arama fonksiyonu
    static async searchStocks(query) {
        if (!query || query.length < 2) return [];

        try {
            console.log('BIST hisse araması:', query);
            
            // Cache'i kontrol et
            await this.ensureCache();
            
            // Query'yi büyük harfe çevir
            const upperQuery = query.toUpperCase();
            
            // Cache'den filtreleme yap
            const results = Array.from(this.stocksCache.entries())
                .filter(([symbol, data]) => {
                    return symbol.includes(upperQuery) || 
                           data.description.toUpperCase().includes(upperQuery);
                })
                .map(([symbol, data]) => ({
                    symbol: symbol,
                    name: data.description,
                    type: 'STOCK',
                    exchange: 'BIST',
                    description: data.description,
                    info: {
                        isStock: true,
                        type: data.type,
                        currency: data.currency
                    }
                }))
                .slice(0, 10); // İlk 10 sonucu al

            return results;

        } catch (error) {
            console.error('BIST arama hatası:', error);
            return [];
        }
    }

    // Hisse detaylarını getir
    static async getStockDetails(symbol) {
        try {
            // bistMap koleksiyonundan veriyi çek
            const docRef = doc(db, 'bistMap', symbol);
            const docSnap = await getDoc(docRef);

            if (!docSnap.exists()) {
                throw new Error('Hisse bulunamadı');
            }

            const data = docSnap.data();
            
            return {
                symbol: symbol,
                name: data.description,
                exchange: data.symbolInfo?.exchange || 'BIST',
                currency: data.currency || 'TRY',
                type: data.type || 'Common Stock',
                sector: data.symbolInfo?.finnhubIndustry || '',
                description: data.description,
                marketCap: data.symbolInfo?.marketCapitalization || 0,
                shareOutstanding: data.symbolInfo?.shareOutstanding || 0
            };

        } catch (error) {
            console.error('Hisse detay hatası:', error);
            return null;
        }
    }

    // Şirket profilini getir
    static async getCompanyProfile(symbol) {
        try {
            const docRef = doc(db, 'bistMap', symbol);
            const docSnap = await getDoc(docRef);

            if (!docSnap.exists()) {
                throw new Error('Şirket profili bulunamadı');
            }

            const data = docSnap.data();
            const symbolInfo = data.symbolInfo || {};

            return {
                name: data.description,
                exchange: symbolInfo.exchange || 'BIST',
                currency: data.currency || 'TRY',
                sector: symbolInfo.finnhubIndustry || '',
                marketCap: symbolInfo.marketCapitalization || 0,
                website: symbolInfo.weburl || ''
            };

        } catch (error) {
            console.error('Şirket profili hatası:', error);
            return null;
        }
    }
}